import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ReactElement } from 'react';
import { SWRConfig } from 'swr';
import { Toaster } from 'react-hot-toast';
import AppShell from './components/AppShell';
import DocsLanding from './pages/DocsLanding';
import DocPage from './pages/DocPage';
import SectionPage from './pages/SectionPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider, useAuth } from './context/AuthContext';

const AdminRoute = ({ children }: { children: ReactElement }) => {
  const { admin } = useAuth();
  if (!admin) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <SWRConfig value={{ revalidateOnFocus: false }}>
          <BrowserRouter>
            <Routes>
              <Route element={<AppShell />}>
                <Route path="/" element={<DocsLanding />} />
                <Route path="/docs/:slug/:sectionSlug" element={<SectionPage />} />
                <Route path="/docs/:slug" element={<DocPage />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <AdminRoute>
                    <AdminDashboard />
                  </AdminRoute>
                }
              />
            </Routes>
          </BrowserRouter>
          <Toaster />
        </SWRConfig>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
